import { useCallback } from "react";
import useWeb3 from "./useWeb3";
import { useWeb3React } from "@web3-react/core";
import { projectContractsConfig } from "../contracts/projectContractsConfig";

const DiscountedPrice = () => {
  const { account } = useWeb3React();
  const web3 = useWeb3();
  const project = localStorage.getItem("project");

  const discountedPrice = useCallback(
    async (round, address) => {
      try {
        const config = projectContractsConfig.find((p) => p.id === project);

        if (!config) {
          throw new Error(`Project configuration not found for: ${project}`);
        }

        const contractConfig = config.contracts.preSale;
        const contract = contractConfig.contract(contractConfig.address, web3);

        const buy = await contract.methods.allowedTokens(round, address).call();
        const price = parseInt(buy[1]) / 10 ** 18;

        return price;
      } catch (error) {
        console.error(`Error getting discounted price for ${project}:`, error);
        throw error;
      }
    },
    [project, account, web3]
  );

  return { discountedPrice };
};

export default DiscountedPrice;
// import { useCallback, useState } from "react";
// import useWeb3 from "./useWeb3";
// import { useWeb3React } from "@web3-react/core";
// import Environment from "../utils/Environment";
// import {
//   getdoproundcreatecontract,
//   getGemsPreSaleContract,
//   getIncentivPreSaleContract,
//   getLEIAPreSaleContract,
//   getOlympusPreSaleContract,
//   getNFAPreSaleContract,
//   getScrexPreSaleContract,
// } from "../utils/contractHelpers";
// const DiscountedPrice = () => {
//   //   const [balance, setBalance] = useState(null)
//   const { account } = useWeb3React();
//   const web3 = useWeb3();
//   const tokenAddress = Environment.DOPRoundSingleContract;
//   const contract = getdoproundcreatecontract(tokenAddress, web3);

//   const gemsAddress = Environment.GEMSPreSale;
//   const incentivAddress = Environment.IncentivPreSale;
//   const LEIAAddress = Environment.LEIAPreSale;
//   const OlympusAddress = Environment.OlympusClaim;
//   const NFAAddress = Environment.NFAClaim;
//   const SCREXAddress = Environment.SCREXPreSale;
//   const CHAINERSAddress = Environment.CHAINERSPreSale;
//   const gemsContractPresale = getGemsPreSaleContract(gemsAddress, web3);
//   const incentivContractPresale = getIncentivPreSaleContract(
//     incentivAddress,
//     web3
//   );

//   const LEIAContractPresale = getLEIAPreSaleContract(LEIAAddress, web3);
//   const OlympusContractPresale = getOlympusPreSaleContract(
//     OlympusAddress,
//     web3
//   );
//   const NFAContractPresale = getNFAPreSaleContract(NFAAddress, web3);
//   const SCREXContractPresale = getScrexPreSaleContract(SCREXAddress, web3);
//   const CHAINERSContractPresale = getScrexPreSaleContract(CHAINERSAddress, web3);
//   const project = localStorage.getItem("project");

//   const discountedPrice = useCallback(
//     async (round, address) => {
//       if (project == "INCENTIV") {
//         try {
//           const buy = await incentivContractPresale.methods
//             .allowedTokens(round, address)
//             .call();

//           const price = parseInt(buy[1]) / 10 ** 18;
//           return price;
//         } catch (error) {
//           throw error;
//         }
//       } else if (project == "SCREX") {
//         try {
//           const buy = await SCREXContractPresale.methods
//             .allowedTokens(round, address)
//             .call();
//           console.log("response hook descoinadsfa: ", buy);

//           const price = parseInt(buy[1]) / 10 ** 18;
//           return price;
//         } catch (error) {
//           throw error;
//         }
//       } else if (project == "CHAINERS") {
//         try {
//           const buy = await CHAINERSContractPresale.methods
//             .allowedTokens(round, address)
//             .call();
//           console.log("response hook descoinadsfa: ", buy);

//           const price = parseInt(buy[1]) / 10 ** 18;
//           return price;
//         } catch (error) {
//           throw error;
//         }
//       } else if (project == "NFA") {
//         try {
//           const buy = await NFAContractPresale.methods
//             .allowedTokens(round, address)
//             .call();
//           console.log("response hook descoinadsfa: ", buy);

//           const price = parseInt(buy[1]) / 10 ** 18;
//           return price;
//         } catch (error) {
//           throw error;
//         }
//       } else if (project == "LEIA") {
//         try {
//           const buy = await LEIAContractPresale.methods
//             .allowedTokens(round, address)
//             .call();

//           const price = parseInt(buy[1]) / 10 ** 18;
//           return price;
//         } catch (error) {
//           throw error;
//         }
//       } else if (project == "OLYMPUS") {
//         try {
//           const buy = await OlympusContractPresale.methods
//             .allowedTokens(round, address)
//             .call();

//           const price = parseInt(buy[1]) / 10 ** 18;
//           return price;
//         } catch (error) {
//           throw error;
//         }
//       } else if (project == "GEMS") {
//         try {
//           const buy = await gemsContractPresale.methods
//             .allowedTokens(round, address)
//             .call();

//           const price = parseInt(buy[1]) / 10 ** 18;
//           return price;
//         } catch (error) {
//           throw error;
//         }
//       } else {
//         try {
//           const buy = await contract.methods
//             .allowedTokens(round, address)
//             .call();

//           const price = parseInt(buy[1]) / 10 ** 18;
//           return price;
//         } catch (error) {
//           throw error;
//         }
//       }
//     },
//     [contract, account, web3]
//   );
//   return { discountedPrice: discountedPrice };
// };
// export default DiscountedPrice;
